/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Popup, Text } from '@cashfree-intl/coherent';
import Lottie from 'react-lottie';

import * as animationData from 'animation/star-loader.json';
import EVENTS from 'constants/analytics';

const InsightsAIPopup = ({
  navigateToInsightsAI,
}: {
  navigateToInsightsAI: () => void;
}) => {
  const defaultOptions = {
    loop: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
      className: '',
    },
  };
  return (
    <Popup
      hoverable
      trigger={
        <div
          className="mr-2 pointer insights-ai"
          onClick={navigateToInsightsAI}
          data-event-name={EVENTS.INSIGHTS_AI.FLOWWISE_WEBAPP_V2_CLICKED}
          data-event-properties={JSON.stringify({ source: 'global_header' })}
          data-ignore-inner-text="true"
        >
          <Lottie options={defaultOptions} height={32} width={32} />
        </div>
      }
    >
      <div>
        <Text className="mb-1">InsightsAI</Text>
        <Text color="bodyLight" variant="b12">
          Cut down payment processing <br /> fee by leveraging differentiated
          <br /> rates across PAs.
        </Text>
      </div>
    </Popup>
  );
};

export default InsightsAIPopup;
